var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmClockCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 3L1.66699 5.5M18.3337 5.5L15.8337 3M5.00033 16.3333L3.33366 18M15.0003 16.3333L16.667 18M7.50033 11.75L9.16699 13.4167L12.917 9.66667M10.0003 18C11.7684 18 13.4641 17.2976 14.7144 16.0474C15.9646 14.7971 16.667 13.1014 16.667 11.3333C16.667 9.56522 15.9646 7.86953 14.7144 6.61929C13.4641 5.36905 11.7684 4.66667 10.0003 4.66667C8.23222 4.66667 6.53652 5.36905 5.28628 6.61929C4.03604 7.86953 3.33366 9.56522 3.33366 11.3333C3.33366 13.1014 4.03604 14.7971 5.28628 16.0474C6.53652 17.2976 8.23222 18 10.0003 18Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockCheckIcon);
export default __webpack_public_path__ + "static/media/alarmClockCheckIcon.53406fa0bb9cf5697df7f4f698cf96bc.svg";
export { ForwardRef as ReactComponent };